module.exports = __webpack_public_path__ + "img/video_bg.8b134daf.jpg";